import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index'
import './assets/main.css'
import { createHead } from '@vueuse/head'
import { vMagnetic } from './directives/vMagnetic'

const head = createHead()
const app = createApp(App)
app.use(head)
app.use(createPinia())
app.use(router)
app.directive('magnetic', vMagnetic)
app.mount('#app')
